module.exports = __webpack_public_path__ + "img/cleaned_sink.6e6304e2.svg";